import react, { useEffect, useState } from "react";
import logo from "./logo.svg";
import Main from "pages/main/Main";
import Detail from "pages/detail/Detail";
import "styles/main.scss";
import { addCollectionAndDocuments, auth } from "services/firebase";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser, setCurrentUser } from "features/user/userSlice";
import { SHOP_DATA } from "pages/shop/Shop";

function App() {
  const [user, setUser] = useState(null);

  let navigate = useNavigate();

  // const currentUser = useSelector((state) => state.user.currentUser);
  const currentUser = useSelector(selectCurrentUser);
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((userState) => {
      if (userState) {
        // setUser(userState);
        dispatch(setCurrentUser(userState));
      } else {
        // setUser(null);
        dispatch(setCurrentUser(null));
      }
    });

    // cleanup
    return () => {
      unsubscribe();
    };
  }, [currentUser, dispatch, navigate]);

  return (
    <div className="App bg-white">
      <Main />
    </div>
  );
}

export default App;
